import Vue from 'vue';
import store from '@/store';
import * as types from './mutation-types';
import CommonProxy from "../../../proxies/CommonProxy";
import AccountsProxy from '@/proxies/AccountsProxy'
import BoardProxy from '@/proxies/BoardProxy';
import moment from 'moment'

export const setMenuTitle = ({ commit }, menuTitle) => {
  commit(types.MENU_TITLE, menuTitle);
};

export const roleFindAll = ({ commit} ) => {
  new CommonProxy()
    .roleFindAll()
    .then((response) => {
      commit(types.ROLES, response);
    })
    .catch(() => {

    })
};

/**
 * 알림 보기
 * @param commit
 */
export const showMainInfo = ({ commit} , mainInfo) => {
  commit(types.MAIN_INFO, mainInfo);

      
    new AccountsProxy()
    .findReadyUser()
    .then( response => {
      if(response.items.length > 0) {
        Vue.prototype.$modal.show(
          () => import('@/components/Pages/Views/Common/ReadyUserListModal.vue'),
          { items: response.items },
          { width:'780px' },
          { }
        )
      }
    })
    
  

};


/**
 * 공지 보기
 * @param commit
 */
export const showNoticeModal = ({ commit} ) => {

    const doNotShow1Day = localStorage.getItem('doNotShow1Day')
    if(doNotShow1Day) {
      const endDate = moment(doNotShow1Day)
      if(endDate.isAfter( moment() )) {
        return
      }
    }
      
    new BoardProxy()
    .getNoticeCount(2)
    .then( response => {
      if(response.count > 0) {

        Vue.prototype.$modal.show(
          () => import('@/components/Pages/Views/Board/ArticleListModal.vue'),
          { boardMst: response.boardMst, boardNo: 2 },
          { width:'1000px' },
          { }
        ).result.then( doNotShow1Day => {
          
          if(doNotShow1Day) {
            const endDate = moment( moment().format('YYYY-MM-DD')+' 23:59:59' ).format('YYYY-MM-DD HH:mm:ss')
            localStorage.setItem('doNotShow1Day',endDate)
          }

        })

      }
    })
    
  

};


export default {
  setMenuTitle,
  roleFindAll,
  showMainInfo,
  showNoticeModal
};
